import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { BizminerPillarInsight } from "@/types/serializers";

export function ScoringSummary({
  analysis,
}: {
  analysis: BizminerPillarInsight["analysis"];
}) {
  const { strongest_category, weakest_category, average_score, categories } =
    analysis;
  if (categories.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm text-muted-foreground">
            Strongest Performance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">
            {strongest_category?.account_score.toFixed(1) ?? "—"}
          </p>
          <p className="text-sm text-muted-foreground truncate">
            {strongest_category?.name ?? "—"}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm text-muted-foreground">
            Weakest Performance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">
            {weakest_category?.account_score.toFixed(1) ?? "—"}
          </p>
          <p className="text-sm text-muted-foreground truncate">
            {weakest_category?.name ?? "—"}
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm text-muted-foreground">
            Average Score
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">
            {average_score != null ? Number(average_score).toFixed(1) : "—"}
          </p>
          <p className="text-sm text-muted-foreground">
            Across {categories.length} categories
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
